import React from "react";
import { formatInTimeZone } from "date-fns-tz";
import { withStyles } from "@mui/styles";

const styles = (theme) => ({
  unavailablePeriod: {
    width: "100%",
    backgroundColor: "#fff",
    padding: 15,
    borderBottom: "1px solid #e6e5e5",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: {
    color: "#000000",
    fontSize: "18px",
    lineHeight: "21px",
  },
});

function UnavailablePeriod({
  classes,
  unavailablePeriod,
  actionButton,
  borderColor,
}) {
  return (
    <div
      className={classes.unavailablePeriod}
      style={{ borderLeft: `5px solid ${borderColor}` }}
    >
      <div>
        {unavailablePeriod.reason && (
          <div className={classes.title}>{unavailablePeriod.reason}</div>
        )}
        {unavailablePeriod.periodStartDate && (
          <div className={classes.title}>
            {formatInTimeZone(
              unavailablePeriod.periodStartDate,
              "UTC",
              "do MMMM yyyy"
            )}{" "}
            -
            {formatInTimeZone(
              unavailablePeriod.periodEndDate,
              "UTC",
              "do MMMM yyyy"
            )}
          </div>
        )}
      </div>
      {actionButton}
    </div>
  );
}

export default withStyles(styles)(UnavailablePeriod);
